import { defineAsyncComponent } from 'vue';

export { default as PurchaseOrderAutoSuggest } from './components/PurchaseOrderAutoSuggest';

export const purchaseOrderMicroFrontends = {
	PurchaseOrderStatusMessage: defineAsyncComponent(
		() =>
			import(
				'./components/PurchaseOrderStatusMessage/PurchaseOrderStatusMessage.vue'
			)
	),
};
